// services/childcare/parent-notes.js
import { api } from "./utils";

// Get all parent notes
export const getParentNotes = async (filters = {}) => {
  try {
    const response = await api.get("/childcare/parent-notes", {
      params: filters,
    });
    return response;
  } catch (error) {
    console.error("Error fetching parent notes:", error);
    throw error;
  }
};

// Get notes by child
export const getNotesByChild = async (childId) => {
  try {
    const response = await api.get(`/childcare/parent-notes/child/${childId}`);
    return response;
  } catch (error) {
    console.error("Error fetching child notes:", error);
    throw error;
  }
};

// Get notes by parent
export const getNotesByParent = async (parentId) => {
  try {
    const response = await api.get(
      `/childcare/parent-notes/parent/${parentId}`,
    );
    return response;
  } catch (error) {
    console.error("Error fetching parent notes:", error);
    throw error;
  }
};

// Create parent note
export const createParentNote = async (noteData) => {
  try {
    const response = await api.post("/childcare/parent-notes", noteData);
    return response;
  } catch (error) {
    console.error("Error creating parent note:", error);
    throw error;
  }
};

// Update parent note
export const updateParentNote = async (id, noteData) => {
  try {
    const response = await api.put(`/childcare/parent-notes/${id}`, noteData);
    return response;
  } catch (error) {
    console.error("Error updating parent note:", error);
    throw error;
  }
};

// Delete parent note
export const deleteParentNote = async (id) => {
  try {
    const response = await api.delete(`/childcare/parent-notes/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting parent note:", error);
    throw error;
  }
};

// Reply to note
export const replyToNote = async (id, replyData) => {
  try {
    const response = await api.post(
      `/childcare/parent-notes/${id}/reply`,
      replyData,
    );
    return response;
  } catch (error) {
    console.error("Error replying to note:", error);
    throw error;
  }
};

// Update note status
export const updateNoteStatus = async (id, status) => {
  try {
    const response = await api.put(`/childcare/parent-notes/${id}/status`, {
      status,
    });
    return response;
  } catch (error) {
    console.error("Error updating note status:", error);
    throw error;
  }
};
